import { render, staticRenderFns } from "./UpcomingOrder.vue?vue&type=template&id=b75f828c&scoped=true"
import script from "./UpcomingOrder.vue?vue&type=script&lang=js"
export * from "./UpcomingOrder.vue?vue&type=script&lang=js"
import style0 from "./UpcomingOrder.vue?vue&type=style&index=0&id=b75f828c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b75f828c",
  null
  
)

export default component.exports